/** @format */

import React, { useRef, useState } from 'react';
import Card from '../../../components/Card/Card';
import CardBody from '../../../components/Card/CardBody';
import GridItem from '../../../components/Grid/GridItem';
import { Button, makeStyles } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import CustomTextButton from '../../../components/Buttons/CustomTextButton';
import Loader from '../../../components/Loaders/Loader';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import { apiCall } from '../../../core/apiCall';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { notificationConstants } from '../../../modules/notifications/notifications';
import { useDispatch } from 'react-redux';
import { Auth } from '../../../modules/auth/Auth';
import COLORS from '../../../assets/themes/OPL/colors';
import { NotificationHelper } from '../../../helpers/NotificationHelper';

const useStyle = makeStyles(adescomStyle);

interface UploadPrefixFileInterface {
    reload: boolean;
    setReload: (reload: boolean) => void;
}
const UploadPrefixFile: React.FC<UploadPrefixFileInterface> = (props) => {
    const { reload, setReload } = props;
    const dispatch = useDispatch();
    const classes = useStyle();

    const [hideUpload, setHideUpload] = useState<boolean>(true);
    const [visibleLoader, setVisibleLoader] = useState<boolean>(false);
    const [file, setFile] = useState<File | null>(null);

    const selectFile = (event: any): void => {
        const file = event.target.files[0];
        setFile(file);
        setHideUpload(false);
    };

    const upload = (): void => {
        if (file) {
            const data = new FormData();
            data.append('file', file);
            data.append('platformUserId', Auth.getUserId().toString());
            apiCall
                .uploadFileCustom(FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/prefix_uploads')), data)
                .then((response: any): void => {
                    setFile(null);
                    setHideUpload(true);
                    setReload(true);
                    NotificationHelper.notifySuccess('prefixes:notify.prefix_csv_added', dispatch);
                })
                .catch((error: any): any => {
                    if (error && error.message && error.message.message) {
                        NotificationHelper.notifyError(error.message.message, dispatch);
                    } else {
                        NotificationHelper.notifyError('prefixes:notify.prefix_csv_error', dispatch);
                    }
                });
        }
    };

    return (
        <Card>
            <CardBody>
                <GridItem xs={12}>
                    <label htmlFor="btn-upload">
                        <input
                            id="btn-upload"
                            name="btn-upload"
                            style={{ display: 'none' }}
                            type="file"
                            onChange={selectFile}
                            accept="text/csv, .csv"
                        />
                        <Button
                            className={`${classes.button} ${classes.md}`}
                            style={{ backgroundColor: COLORS.MAIN.PRIMARY, height: 50 }}
                            component="span"
                        >
                            <I18n trans="prefixes:b.choose_prefix_file" />
                        </Button>
                    </label>
                    {!hideUpload && (
                        <CustomTextButton
                            size={'lg'}
                            color={'primary'}
                            label={'prefixes:b.upload_prefix_file'}
                            callback={upload}
                            callbackParam={{}}
                        />
                    )}
                </GridItem>
                <Loader visible={visibleLoader} />
            </CardBody>
        </Card>
    );
};

export default UploadPrefixFile;
